import { CloseOutlined } from "@ant-design/icons";

type Props = {
	onClick: () => void;
	text?: string;
};

export function CloseButton({ onClick, text }: Props): React.ReactNode {
	return (
		<button
			aria-label={text}
			className="ant-modal-close"
			type="button"
			onClick={onClick}
		>
			<span className="ant-modal-close-x h-[40px]! w-[40px]! leading-[40px]!">
				<CloseOutlined className="ant-modal-close-icon" />
			</span>
		</button>
	);
}
